import { BannerHTML5Props } from '.';
import styles from './BannerHTML5.module.scss';
import { AnchorLink } from 'components/anchorLink';

export const BannerHTML5 = ({ text, buttonLabel, url }: BannerHTML5Props) => {
  const defaultText = "Prova l'App Sport senza scaricare";
  const defaultButtonLabel = 'Prova ora';

  return (
    <div className={styles.container} suppressHydrationWarning>
      <p className={styles.text} suppressHydrationWarning>
        {text ?? defaultText}
      </p>
      <AnchorLink isButton className={styles.button} visualizationType="tertiary" href={url} target="_self">
        {buttonLabel ?? defaultButtonLabel}
      </AnchorLink>
    </div>
  );
};
